export const PanEvent = Object.freeze({
  PAN_START: "panstart",
  PAN_MOVE: "panmove",
  PAN_END: "panend",
  PAN_CANCEL: "pancancel",
  SWIPE: "swipe",
  SWIPE_UP: "swipeup",
  SWIPE_DOWN: "swipedown",
  SWIPE_LEFT: "swipeleft",
  SWIPE_RIGHT: "swiperight",
});

export const PanGesture = Object.freeze({
  PAN: "pan",
  SWIPE: "swipe",
});
